import React from "react";

interface Props {
    body: string;
    title?: string
    date: Date
    link?: string
    images?: string[]
    featured?: boolean
}

export const Announcement = (props: Props) => {
    return (
        <article className={props.featured ? 'announcement-card featured' : 'announcement-card'}>
            {props.title && <h3 className={'announcement-title'}>{props.title}</h3>}
            <p className={'announcement-date'}>Updated on : {props.date.toLocaleDateString()}</p>
            <p className={'announcement-body'}>{props.body}{props.link && <a href={props.link}> Klik hier!</a>}</p>
            {props.images && (
                <div className="d-flex flex-wrap mt-3">
                    {props.images.map((image, idx) => (
                        <img key={idx} className={'announcement-image me-2 mb-2 img-fluid'} alt={'announcement'}
                             src={image}/>
                    ))}
                </div>
            )}
        </article>
    )
}
